/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ChangePasswordMutationInput = {
    password: string;
    confirmPassword: string;
    clientMutationId?: string | null | undefined;
};
export type ChangePasswordMutationVariables = {
    input: ChangePasswordMutationInput;
};
export type ChangePasswordMutationResponse = {
    readonly changePassword: {
        readonly user: {
            readonly id: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly email: string;
            readonly avatar: string | null;
        } | null;
    } | null;
};
export type ChangePasswordMutation = {
    readonly response: ChangePasswordMutationResponse;
    readonly variables: ChangePasswordMutationVariables;
};



/*
mutation ChangePasswordMutation(
  $input: ChangePasswordMutationInput!
) {
  changePassword(input: $input) {
    user {
      id
      firstName
      lastName
      email
      avatar
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangePasswordMutationPayload",
    "kind": "LinkedField",
    "name": "changePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avatar",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c49186dc9f0248df44ef295a4f755cea",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordMutation(\n  $input: ChangePasswordMutationInput!\n) {\n  changePassword(input: $input) {\n    user {\n      id\n      firstName\n      lastName\n      email\n      avatar\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8b951d7593a493b0ccc81681be04f5af';
export default node;
